import { FC, ImgHTMLAttributes, useState } from 'react';

import { Skeleton } from './Skeleton';

export const Image: FC<ImgHTMLAttributes<HTMLImageElement>> = ({
    src,
    alt,
    className,
    ...imgProps
}) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);

    return (
        <>
            {(!isLoaded || hasError) && <Skeleton />}
            <img
                src={src}
                alt={alt}
                className={className}
                style={{
                    height: isLoaded && !hasError ? '100%' : 0,
                }}
                onLoad={() => {
                    setIsLoaded(true);
                }}
                onError={() => {
                    setHasError(true);
                    setIsLoaded(false);
                }}
                {...imgProps}
            />
        </>
    );
};
